import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import PageSectionGroupLayout from "@Client/@Modules/application-standalone/components/layout/page-section-group-layout.vue";
import { computed, defineComponent, toRefs, watch } from "@vue/composition-api";
import TextField from "@Shared/components/form-elements/fields/text-field.vue";
import SelectField from "@Shared/components/form-elements/fields/select-field.vue";
import CurrencyField from "@Shared/components/form-elements/fields/currency-field.vue";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { APPLICATION_FIELD_OPTIONS } from "@Shared/@Utils/application-defaults-utils/global-field-options";
import { additionalIncomeBindingsAndVisibilities } from "@Client/@Composables/application-standalone/pages/income-history/additionalIncomeBindingsAndVisibilities";
import { additionalIncomeValidator } from "@Client/@Composables/application-standalone/validations/additionalIncomeValidator";
import { get } from "lodash";
export default defineComponent({
  name: "AdditionalIncomeInformation",
  components: {
    PageSectionGroupLayout,
    SectionTitle,
    TextField,
    SelectField,
    CurrencyField
  },
  props: {
    applicantIndex: {
      type: Number,
      required: true
    },
    incomeIndex: {
      type: Number,
      required: true
    },
    showErrors: {
      type: Number,
      default: 0
    }
  },
  setup(props, {
    emit
  }) {
    const {
      applicantIndex,
      incomeIndex,
      showErrors
    } = toRefs(props);
    const {
      applicantNameFromIndex,
      applicantsAsOptions
    } = useApplicantHelpers();
    const applicantName = applicantNameFromIndex(applicantIndex.value);
    const {
      bindings,
      visibilities
    } = additionalIncomeBindingsAndVisibilities(applicantIndex, incomeIndex);
    const {
      additionalIncomeAmount,
      additionalIncomeDescription,
      additionalIncomeIncomePeriod,
      additionalIncomeType
    } = bindings;
    const {
      additionalIncomeAmountVisible,
      additionalIncomeDescriptionVisible,
      additionalIncomeTypeVisible,
      additionalIncomeIncomePeriodVisible
    } = visibilities;
    const {
      additionalIncomeTypeOptions,
      applicantIncomePeriodOptions
    } = APPLICATION_FIELD_OPTIONS();
    const {
      v$
    } = additionalIncomeValidator(applicantIndex, incomeIndex);
    const isValid = computed(() => {
      var _v$$value;
      return !(v$ != null && (_v$$value = v$.value) != null && _v$$value.$invalid);
    });
    watch(isValid, newVal => {
      emit("disable-save", !newVal);
    }, {
      immediate: true
    });
    watch(showErrors, newVal => {
      if (newVal) {
        var _v$$value2;
        v$ == null ? void 0 : (_v$$value2 = v$.value) == null ? void 0 : _v$$value2.$touch();
      }
    });
    const getValidator = path => get(v$.value, path, null);
    return {
      applicantName,
      additionalIncomeAmount,
      additionalIncomeDescription,
      additionalIncomeIncomePeriod,
      additionalIncomeType,
      additionalIncomeTypeOptions,
      applicantIncomePeriodOptions,
      applicantsAsOptions,
      additionalIncomeAmountVisible,
      additionalIncomeDescriptionVisible,
      additionalIncomeTypeVisible,
      additionalIncomeIncomePeriodVisible,
      v$,
      getValidator
    };
  }
});